export const sampleTasks = [
    "Schedule org meeting",
    "Create teaser deck",
    "Engage market study provider",
    "Send letter of intent",
    "Engage NDA processor",
    "Setup data room",
]